export default __webpack_public_path__ + "static/media/bg_community_setting.2e05cf39.jpg";